import React from 'react';
import '../../../styles/Commons.css';
import { Card, Col, Row, Tag } from "antd";
import Ingredient from "../../../model/menudesign/Ingredient";

interface ingr {
    ingredient: Ingredient
}

const IngredientList = ({ ingredient }: ingr) => {
    return (
        <Card bordered={true}>
            <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row">
                            <b>Alergia</b>
                        </Col>
                        <Col className="gutter-row">
                            {ingredient.alergia == 1 && ingredient.alergen_ingredient?.length > 0 ? (
                                ingredient.alergen_ingredient.map((alerg, index) => (
                                    <Tag key={index} color="yellow">
                                        {alerg.nom}
                                    </Tag>
                                ))
                            ) : (
                                <Tag color="magenta">No al·lergens</Tag>
                            )}

                        </Col>
                    </Row>
                </Col>
                 <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Preu</b></Col>
                        <Col className="gutter-row"><div>{ingredient.preu} &euro;</div></Col>
                    </Row>
                </Col>
                
                
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Minim Stock</b></Col>
                        <Col className="gutter-row"><div>{ingredient.minim_stock}</div></Col>
                    </Row>
                </Col>
                

                
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Proveidor 1</b></Col>
                        <Col className="gutter-row"><div>{ingredient.proveidor1}</div></Col>
                    </Row>
                </Col>
            </Row>

            <br />

            <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Proposta</b></Col>
                        <Col className="gutter-row"> 
                            <Tag color={ingredient.proposta == "1" ? "cyan" : "magenta"}>
                                {ingredient.proposta == "1" ? "Proposta" : "No proposta"}
                            </Tag>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Mesura</b></Col>
                        <Col className="gutter-row"><div>{ingredient.mesura}</div></Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Arrodoniment Comanda</b></Col>
                        <Col className="gutter-row"><div>{ingredient.arrodoniment_comanda}</div></Col>
                    </Row>
                </Col>
               
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Proveidor 2</b></Col>
                        <Col className="gutter-row"><div>{ingredient.proveidor2}</div></Col>
                    </Row>
                </Col>

                
            </Row>

            <br />

            <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Precisa cuina:</b></Col>
                        <Col className="gutter-row">
                            <Tag color={ingredient.cuina == "1" ? "lime" : "magenta"}>
                                {ingredient.cuina == "1" ? "cuinat" : "No cuinat"}
                            </Tag>
                        </Col>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Variants (Menú)</b></Col>
                          { ingredient.variacio_ingredient?.length > 0 ? (
                                ingredient.variacio_ingredient.map((varia, index) => (
                                    <Tag key={index} color="green">
                                        {varia.nom}
                                    </Tag>
                                ))
                            ) : (
                                <Tag color="magenta">No variants</Tag>
                            )}
                        
                    </Row>
                </Col>
               
                 <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Arrodoniment Repartir</b></Col>
                        <Col className="gutter-row"><div>{ingredient.arrodoniment_repartir}</div></Col>
                    </Row>
                </Col>
              
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Fitxa Tècnica 1</b></Col>
                        <Col className="gutter-row"><div>{ingredient.fitxaTecnica}</div></Col>
                    </Row>
                </Col>

                
                
            </Row>
             <Row gutter={16}>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                    </Row>
                </Col>
                <Col className="gutter-row" span={6}>
                    <Row gutter={16}>
                        <Col className="gutter-row"><b>Fitxa Tècnica 2</b></Col>
                        <Col className="gutter-row"><div>{ingredient.fitxaTecnica2}</div></Col>
                    </Row>
                </Col>
             </Row>

        </Card>
    );
};

export default IngredientList;
